const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

// A word can have a second recording (`<id>-2.mp3`, another take of the same word).
// Repeat plays both, `gapMs` apart; the first play of a word plays only the first.
//
// `play(url, onStart)` resolves when the clip has ended and rejects if it cannot
// start. The first clip's failure is passed on, so the caller can fall back to
// speech. The second clip is a bonus: if it is missing, fails or hangs, the word
// has already been said, so the sequence just ends. `wanted()` turns false once
// the prompt is stale (graded, stopped, replaced) and stops the second clip.
export async function playTakes({ play, url, secondUrl = null, exists, preload, onStart, wanted = () => true, gapMs = 1000, giveUpMs = 8000 }) {
  // Look for the second clip while the first plays, and have it ready by then.
  const second = secondUrl && exists(secondUrl)
    .then(found => { if (found) preload?.(secondUrl); return found; })
    .catch(() => false);
  await play(url, onStart);
  if (!second || !(await second) || !wanted()) return;
  await sleep(gapMs);
  if (!wanted()) return;
  try { await Promise.race([play(secondUrl), sleep(giveUpMs)]); } catch (_) {}
}
